module.exports = __webpack_public_path__ + "img/NachdemBaden.163e09af.svg";